import { useState } from "react";
import { IDevice } from "../types";

export function useRows() {
  const [rows, setRows] = useState<IDevice[]>([]);

  const onUpdateRows = (picked: any[]) => {
    setRows(picked);
  };

  const onRemoveRow = (selectedIds: Set<number>) => {
    setRows(rows.filter((row) => !selectedIds.has(row.id)));
  };

  return { rows, setRows, onUpdateRows, onRemoveRow };
}
